import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
import { comparison } from '../../data/home';
import { formatPrice } from '../../utils/currency';
export function CompareTypes() {
  const [plug, home] = comparison.columns;
  return <section aria-labelledby="compare-heading" className="mx-auto max-w-7xl px-4 py-14 sm:px-6 lg:px-8 lg:py-20" data-id="element-120" data-mp="iqxo94566sui">
      <div className="grid gap-8 lg:grid-cols-12 lg:gap-12" data-id="element-121" data-mp="1fhq4q2w0mmwt">
        <div className="lg:col-span-4" data-id="element-122" data-mp="1ff3v7xpkdxby">
          <h2 id="compare-heading" className="text-2xl font-bold tracking-tight text-ink sm:text-[28px]" data-id="element-123" data-mp="1bf3a5u7ymnvx">
            Stekkerbatterij of vaste thuisbatterij?
          </h2>
          <p className="mt-3 text-[15px] leading-relaxed text-muted" data-id="element-124" data-mp="11hfcavf2509j">
            De belangrijkste keuze vóór je gaat vergelijken. Twijfel je nog? Doe de batterijcheck of bel een van onze technici.
          </p>
          <Link to="/#advisor" className="mt-5 inline-flex items-center gap-1.5 text-sm font-semibold text-ink underline underline-offset-4" data-id="element-125" data-mp="3m7xm7c5cxn4j">
            Doe de batterijcheck
          </Link>
        </div>

        <div className="-mx-4 overflow-x-auto px-4 sm:mx-0 sm:px-0 lg:col-span-8" data-id="element-126" data-mp="2d3jlsbwqp76s">
          <table className="w-full min-w-[560px] border-collapse text-left text-sm" data-id="element-127" data-mp="1z38td4fs7kji">
            <thead data-id="element-128" data-mp="1z5mm36mzoknw">
              <tr data-id="element-129" data-mp="2423ck7hnvb45">
                <th scope="col" className="w-[28%] pb-5 align-bottom" data-id="element-130" data-mp="241k37f62tv1q">
                  <span className="sr-only" data-id="element-131" data-mp="1pdgu3wwqm38p">Kenmerk</span>
                </th>
                {[plug, home].map(c => <th key={c.id} scope="col" className="px-4 pb-5 align-bottom font-normal" data-id="element-132" data-mp="1u4fep8ordnhr">
                    <span className="block text-lg font-bold text-ink" data-id="element-133" data-mp="1gdak4l08zlea">{c.title}</span>
                    <span className="block text-xs text-muted" data-id="element-134" data-mp="1lbluqxyd9zxk">{c.tagline}</span>
                    <span className="mt-2 block text-sm text-ink" data-id="element-135" data-mp="1l9hm62piwcqy">
                      vanaf <span className="font-bold" data-id="element-136" data-mp="16fcz06doq4pw">{formatPrice(c.from)}</span>
                    </span>
                  </th>)}
              </tr>
            </thead>
            <tbody data-id="element-137" data-mp="s9uiqsujy5ij">
              {comparison.rows.map(r => <tr key={r.label} className="border-t border-line" data-id="element-138" data-mp="nht0mqapdkkl">
                  <th scope="row" className="py-3.5 pr-4 font-medium text-muted" data-id="element-139" data-mp="nghwgpdciasy">
                    {r.label}
                  </th>
                  <td className="px-4 py-3.5 font-medium text-ink" data-id="element-140" data-mp="dkokb73jgjbp">{r.plug}</td>
                  <td className="px-4 py-3.5 font-medium text-ink" data-id="element-141" data-mp="1b7nb517jux1o">{r.home}</td>
                </tr>)}
            </tbody>
            <tfoot data-id="element-142" data-mp="169vl6cqgtl04">
              <tr className="border-t border-line" data-id="element-143" data-mp="169diax9as8j8">
                <td data-id="element-144" data-mp="1197ujs65f66f" />
                {[plug, home].map((c, i) => <td key={c.id} className="px-4 pt-5" data-id="element-145" data-mp="11bka5yofp4gb" data-mpi={i}>
                    <Link to={c.href} className={`inline-flex h-11 w-full items-center justify-center gap-2 whitespace-nowrap rounded-lg px-4 text-sm font-semibold transition-colors duration-150 ${i === 0 ? 'border border-ink text-ink hover:bg-ink hover:text-white' : 'bg-ink text-white hover:bg-ink-soft'}`} data-id="element-146" data-mp="w9uwscdqoep2">
                      {c.cta}
                      <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-147" data-mp="26h0ox412izis" />
                    </Link>
                  </td>)}
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    </section>;
}